import CryptoJS from 'crypto-js'
import Crypto from 'crypto-browserify'
import queryString from 'query-string'
import { Buffer } from 'buffer'
import { configs } from "../configs/config"
import moment from 'moment'
import jwt_decode from "jwt-decode"
import axios from "axios"
import Setting from '../configs/Setting'
import fileDownload from 'js-file-download'
import { gima } from 'gima-common'
export const safeDecodeFileName = (name) => {
  if (!name) return name
  try {
    return decodeURIComponent(name)
  } catch {
    return name
  }
}

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = obj => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

export const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

export const getCookie = (cname) => {
  const name = `${cname}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return null
}

export const delete_cookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

export const siteModeisPRD = !window.location.href.includes("localhost")

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  // return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
  return new Intl.DateTimeFormat('en-US', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value))
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)

  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

//Returns 1st letter of First name last name and dislay in avtar(if avtar not available)
export const getDisplayName = (name) => {
  const str = name
  const matches = str.match(/\b(\w)/g) // ['J','S','O','N']
  const acronym = matches?.slice(0, 2)?.join('') // JSON
  return acronym
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
// export const isUserLoggedIn = () => { return siteModeisPRD ? getCookie("Token") ? getCookie("Token") : localStorage.getItem('userData') : localStorage.getItem('userData') }
export const isUserLoggedIn = () => gima.getToken()
export const loginToken = () => gima.getToken()
export const getUserData = () => gima.getTokenInfo()

export const getAppConfig = () => JSON.parse(localStorage.getItem('base_urls'))

const setThemeColor = async () => {
  try {
    const { data } = await axios.get(`${configs.REACT_APP_GIMA_THEME_API}?companycode=${getUserData()?.company_code || ""}&environment=${getUserData()?.environment || ""}`)
    if (data) {
      const system_config = data.Data.find((x) => x?.sys_settings?.length > 0)?.sys_settings || []
      // localStorage.setItem("company_data", JSON.stringify(data?.Data[0] || null))
      sessionStorage.setItem("company_data", JSON.stringify(data?.Data[0] || null))

      localStorage.setItem("theme_color", data?.Data[0]?.theme_colour)
      localStorage.setItem("system_config", JSON.stringify(system_config || []))
    }
  } catch (err) { }
}

// if (getUserData()) {
//   setThemeColor()
// }

export const getCompanyConfig = () => {
  const localThemeColor = localStorage.getItem("theme_color")
  const localCompanyData = JSON.parse(sessionStorage.getItem('company_data'))
  if (localThemeColor === "undefined") {
    localStorage.setItem("theme_color", getUserData()?.theme_Color)
    return {
      ...getUserData(), theme_colour: getUserData()?.theme_Color
    }
  }
  return localCompanyData
}

export const getBusinessData = () => JSON.parse(sessionStorage.getItem('businessData'))
/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return '/access-control'
  return '/login'
}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
})
export const encryptString = (form, string) => {
  const encrypted = CryptoJS.AES.encrypt(
    string,
    CryptoJS.enc.Utf8.parse(form.aeskey),
    {
      iv: CryptoJS.enc.Utf8.parse(form.aesiv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  )
  return encrypted.toString()
}
export const decryptString = (form, string) => {
  const decrypted = CryptoJS.AES.decrypt(string, CryptoJS.enc.Utf8.parse(form.aeskey), {
    iv: CryptoJS.enc.Utf8.parse(form.aesiv),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}
export const findKey = (item, searchKey) => {
  for (const key in item) {
    if (item[key].children && item[key].children.length > 0) {
      return findKey(item[key].children, searchKey)
    } else {
      if (item[key].field && item[key].field === searchKey) {
        return item[key]
      }
    }
  }
}

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 B'
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  const floated = parseFloat((bytes / Math.pow(k, i)).toFixed(dm))
  // if (!floated || !sizes[i]) return '0 B'
  if (!floated || !sizes[i]) return { size: 0, key: "B" }
  // return `${floated} ${sizes[i]}`
  return { size: floated, key: sizes[i] }
}

export const stringToHTML = str => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(str, 'text/html')
  return doc.body.innerText.replaceAll('�', '')
}

export const truncateString = (str, n) => {
  if (str && str.length > n) {
    return `${str.substr(0, 20)}...${str.substr(str.length - 10, str.length)}`
  }
  return str
}

export const findKeyAndAssign = (item, values) => {
  // console.log(item)
  for (const key in item) {
    if (item[key].children && item[key].children.length > 0) {
      findKeyAndAssign(item[key].children, values)
    } else {
      if (item[key].field && values[item[key].field] !== undefined) {
        if (values[item[key].field]) {
          if (item[key].props) {
            item[key].props.value = values[item[key].field]
          } else {
            item[key].props = {
              value: values[item[key].field]
            }
          }
        }
      }
    }
  }
  return item
}
export const aesEncryption = (form, component, formData) => {
  const newFormData = new FormData()
  for (const pair of formData.entries()) {
    const item = findKey(component, pair[0])
    if (item && item.props && item.props.aesEnable) {
      newFormData.append(pair[0], (pair[1] !== '') ? encryptString(form, pair[1]) : pair[1])
    } else {
      newFormData.append(pair[0], pair[1])
    }
  }
  return newFormData
}

export const uuidv4 = () => {
  let d = new Date().getTime()//Timestamp
  let d2 = (performance && performance.now && (performance.now() * 1000)) || 0 //Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16//random number between 0 and 16
    if (d > 0) { //Use timestamp until depleted
      r = (d + r) % 16 | 0
      d = Math.floor(d / 16)
    } else { //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0
      d2 = Math.floor(d2 / 16)
    }
    return (c === 'x' ? r : (r && (0x3 || 0x8))).toString(16)
  })
}

export const getParameterByName = (name, url = window.location.href) => {
  name = name.replace(/[\[\]]/g, '\\$&')
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}
export const parUrlSearchString = (urlQueryString) => {
  const queryStringNew = {}
  for (const key in urlQueryString) {
    if (urlQueryString[key].includes('local')) {
      let getForLocal = urlQueryString[key].split('.')
      getForLocal = urlQueryString[key].replace('local.', '')
      getForLocal = getForLocal.split('.')
      let itemValue = ''
      if (getForLocal.length === 1) {
        itemValue = localStorage.getItem(getForLocal[0])
      } else {
        getForLocal.map((val, index) => {
          if (index === 0) {
            itemValue = JSON.parse(localStorage.getItem(val))
          } else {
            itemValue = itemValue[val]
          }
        })
      }
      queryStringNew[key] = itemValue
    } else if (urlQueryString[key].includes('params')) {
      if (getParameterByName('id')) {
        queryStringNew[key] = getParameterByName('id')
      }
    } else {
      queryStringNew[key] = urlQueryString[key]
    }
  }
  return queryStringNew
}
export const parseUrlPaths = (findPaths) => {
  const paths = []
  findPaths.map((item) => {
    if (item.includes('local')) {
      let getForLocal = item.split('.')
      getForLocal = item.replace('local.', '')
      getForLocal = getForLocal.split('.')
      let itemValue = ''
      if (getForLocal.length === 1) {
        itemValue = localStorage.getItem(getForLocal[1])
      } else {
        getForLocal.map((val, index) => {
          if (index === 0) {
            itemValue = JSON.parse(localStorage.getItem(val))
          } else {
            itemValue = itemValue[val]
          }
        })
      }
      paths.push(itemValue)
    } else if (item.includes('params')) {
      let paramSplit = item.split('.')
      paramSplit = paramSplit[paramSplit.length - 1]
      if (getParameterByName(paramSplit)) {
        paths.push(getParameterByName(paramSplit))
      }
    } else {
      paths.push(item)
    }
  })
  return paths
}

export const parseUrltoSend = (url) => {
  try {
    let unparsedUrl = ''
    try {
      unparsedUrl = new URL(url)
    } catch (e) {
      if (url.startsWith('local')) {
        const urlSplit = url.split('/')
        const parsedPath = parseUrlPaths(urlSplit)
        urlSplit[0] = parsedPath[0]
        unparsedUrl = urlSplit.join('/')
      } else {
        unparsedUrl = new URL(`${getAppConfig().gimaApiDomain}${url}`)
      }
    }
    const urlQueryString = queryString.parse(unparsedUrl.search)
    const queryStringNew = parUrlSearchString(urlQueryString)
    const parsedUrl = queryString.stringify(queryStringNew)
    const finalUrl = new URL(unparsedUrl)
    // console.log(finalUrl)
    const paths = parseUrlPaths(finalUrl.pathname.split('/'))
    // console.log(`${finalUrl.origin}${paths.join('/')}?${parsedUrl}`)
    return `${finalUrl.origin}${paths.join('/')}?${parsedUrl}`
  } catch {
    return url
  }

}

export const getPermissionByName = (menuItems, menuName, property = 'func_id') => {
  let can_add = false, can_edit = false, can_delete = false, can_read = false, menu_name = menuName
  for (let key = 0; key < menuItems.length; key++) {
    if (menuItems[key][property] === menuName) {
      can_read = menuItems[key].can_read === 'Y'
      can_add = menuItems[key].can_add === 'Y'
      can_edit = menuItems[key].can_edit === 'Y'
      can_delete = menuItems[key].can_delete === 'Y'
      menu_name = menuItems[key].func_name
    } else {
      if (menuItems[key].child_menu && menuItems[key].child_menu.length > 0) {
        for (let keyOne = 0; keyOne < menuItems[key].child_menu.length; keyOne++) {
          if (menuItems[key].child_menu[keyOne][property] === menuName) {
            can_read = menuItems[key].child_menu[keyOne].can_read === 'Y'
            can_add = menuItems[key].child_menu[keyOne].can_add === 'Y'
            can_edit = menuItems[key].child_menu[keyOne].can_edit === 'Y'
            can_delete = menuItems[key].child_menu[keyOne].can_delete === 'Y'
            menu_name = menuItems[key].child_menu[keyOne].func_name
          } else if (menuItems[key].child_menu && menuItems[key].child_menu[keyOne].child_menu && menuItems[key].child_menu[keyOne].child_menu.length > 0) {
            for (let childKey = 0; childKey < menuItems[key].child_menu[keyOne].child_menu.length; childKey++) {
              if (menuItems[key].child_menu[keyOne].child_menu[childKey][property] === menuName) {
                can_read = menuItems[key].child_menu[keyOne].child_menu[childKey].can_read === 'Y'
                can_add = menuItems[key].child_menu[keyOne].child_menu[childKey].can_add === 'Y'
                can_edit = menuItems[key].child_menu[keyOne].child_menu[childKey].can_edit === 'Y'
                can_delete = menuItems[key].child_menu[keyOne].child_menu[childKey].can_delete === 'Y'
                menu_name = menuItems[key].child_menu[keyOne].child_menu[childKey].func_name
              }
            }
          }
        }
      }
    }
  }
  return { can_add, can_edit, can_delete, can_read, menu_name }
}

export const getMenuByUrl = (menuItems, link) => {
  let item
  for (let key = 0; key < menuItems.length; key++) {
    if (menuItems[key].func_id === link) {
      item = menuItems[key]
    } else {
      if (menuItems[key].child_menu && menuItems[key].child_menu.length > 0) {
        for (let keyOne = 0; keyOne < menuItems[key].child_menu.length; keyOne++) {
          if (menuItems[key].child_menu[keyOne].func_id === link) {
            item = menuItems[key].child_menu[keyOne]
          }
        }
      }
    }
  }
  return item
}

export const getMenuByDomain = (menuItems, link) => {
  let item
  for (let key = 0; key < menuItems.length; key++) {
    if (menuItems[key].link.includes(link)) {
      item = menuItems[key]
    } else {
      if (menuItems[key].child_menu && menuItems[key].child_menu.length > 0) {
        for (let keyOne = 0; keyOne < menuItems[key].child_menu.length; keyOne++) {
          if (menuItems[key].child_menu[keyOne].link.includes(link)) {
            item = menuItems[key].child_menu[keyOne]
          }
        }
      }
    }
  }
  return item
}

export const setCookie = (name, value, days) => {
  let expires = ""
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = `; expires=${date.toUTCString()}`
  }
  document.cookie = `${name}=${(value || "")};${expires};path=/`
}

export const getParamsFromHashUrl = (url) => {
  const [hash, params] = url.split('#')[1].split('?')
  const paramsObj = Object.fromEntries(new URLSearchParams(params))
  return paramsObj
}
export const getPincode = (string) => {
  const buf = Buffer.from(string)
  const md5Val = Crypto.createHash('md5')
  const m = md5Val.update(buf).digest()
  let result = m[0].toString() + m[1].toString() + m[2].toString() + m[3].toString() + m[4].toString() + m[5].toString()
  if (result.length > 6) {
    result = result.substr(0, 6)
  }
  return result
}

export const assignLocalValue = (value) => {
  //console.log(value)
  if (String(value).startsWith('func')) {
    if (value === 'func.uuid') {
      return uuidv4()
    } else if (value === 'func.date') {
      return moment(new Date).format('YYYY-MM-DD HH:MM:00')
    } else {
      return value
    }
  } else if (value.startsWith('local')) {
    let getForLocal = value.split('.')
    getForLocal = value.replace('local.', '')
    getForLocal = getForLocal.split('.')
    let itemValue = ''
    if (getForLocal.length === 1) {
      itemValue = localStorage.getItem(val)
    } else {
      getForLocal.map((val, index) => {
        if (index === 0) {
          itemValue = JSON.parse(localStorage.getItem(val))
        } else {
          itemValue = itemValue[val]
        }
      })
    }
    return itemValue
  } else {
    return value
  }

}
export const getPropByString = (obj, propString) => {
  if (!propString) return obj
  const props = propString.split('.')
  let prop = props
  let i = 0
  const iLen = props.length - 1
  for (i, iLen; i < iLen; i++) {
    prop = props[i]
    const candidate = obj[prop]
    if (candidate !== undefined) {
      obj = candidate
    } else {
      break
    }
  }
  return obj[props[i]]
}

export const parseJwt = (token) => {
  return jwt_decode(token)
}

export function fallbackCopyTextToClipboard(text) {
  return new Promise((res, rej) => {
    const textArea = document.createElement("textarea")
    textArea.value = text

    // Avoid scrolling to bottom
    textArea.style.top = "0"
    textArea.style.left = "0"
    textArea.style.position = "fixed"

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      const successful = document.execCommand('copy')
      const msg = successful ? 'successful' : 'unsuccessful'
      res(`Fallback: Copying text command was ${msg}`)
    } catch (err) {
      rej('Fallback: Oops, unable to copy', err)
    }

    document.body.removeChild(textArea)
  })

}

export const getLocalTime = (date) => {
  const dateVal = String(date).split(" ")
  if (dateVal.length === 2) {
    return new Date(`${dateVal[0]}T${dateVal[1]}.000Z`)
  } else {
    return ""
  }
}
export const inIframe = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

export const applyDefaultFont = (str = "", fontfamily = "Arial", fontSize = "12pt") => {
  if (str.includes("<p>")) {
    str = str.replaceAll("<p>", `<p style='font-family: ${fontfamily}; font-size: ${fontSize};'>`)
  }
  if (str.includes("<h1>")) {
    str = str.replaceAll("<h1>", `<h1 style='font-family: ${fontfamily}; font-size: ${fontSize};'>`)
  }
  if (str.includes("<h2>")) {
    str = str.replaceAll("<h2>", `<h2 style='font-family: ${fontfamily}; font-size: ${fontSize};'>`)
  }
  if (str.includes("<h3>")) {
    str = str.replaceAll("<h3>", `<h3 style='font-family: ${fontfamily}; font-size: ${fontSize};'>`)
  }
  if (str.includes("<h4>")) {
    str = str.replaceAll("<h4>", `<h4 style='font-family: ${fontfamily}; font-size: ${fontSize};'>`)
  }
  if (str.includes("<h5>")) {
    str = str.replaceAll("<h5>", `<h5 style='font-family: ${fontfamily}; font-size: ${fontSize};'>`)
  }
  if (str.includes("<h6>")) {
    str = str.replaceAll("<h6>", `<h6 style='font-family: ${fontfamily}; font-size: ${fontSize};'>`)
  }
  if (str.includes("<h6>")) {
    str = str.replaceAll("<h6>", `<h6 style='font-family: ${fontfamily}; font-size: ${fontSize}'>`)
  }
  return str
}

export const applyFwRe = (str = "") => {
  const checkmates = ["FW:", "Fw:", "转发:", "轉發:", "转发:", "轉發:", "RE:", "Re:", "回复:", "回復:", "回复:", "回復:", "答复:", "答复:", "答復:", "答復:"]
  if (checkmates.includes(str.slice(0, 3))) {
    str = str?.replace("FW:", "")?.replace("Fw:", "")?.replace("转发:", "")?.replace("轉發:", "")?.replace("转发:", "")?.replace("轉發:", "")?.replace("RE:", "")?.replace("Re:", "")?.replace("回复:", "")?.replace("回復:", "")?.replace("回复:", "")?.replace("回復:", "")?.replace("答复:", "")?.replace("答复:", "")?.replace("答復:", "")?.replace("答復:", "")
  }
  return str
}

export const downloadAttachment = (file) => {
  if (file?.FolderFileNo || file?.FileNo) {
    const form = document.createElement("form")
    const element1 = document.createElement("input")
    const element2 = document.createElement("input")
    form.method = "POST"
    form.action = `${Setting.dmsDownloadAPI}?CompanyCode=${Setting.cred.CompanyCode}&StaffCode=${Setting.cred.StaffCode}`
    form.target = '_blank'
    element1.type = 'hidden'
    element1.value = file?.FolderFileNo || file?.FileNo
    element1.name = 'FilesNo'

    element2.type = 'hidden'
    element2.value = `Bearer ${gima.getToken()}`
    element2.name = 'JwtToken'

    form.appendChild(element1)
    form.appendChild(element2)

    document.body.appendChild(form)
    form.submit()
  } else if (file?._id) {
    const downloadUrl = `${Setting.mailServerAPI}/email/DownloadEmailAttachment/${file?._id}?companycode=${Setting.cred.CompanyCode}&token=${gima.getToken()}`

    axios.get(downloadUrl).then((res) => {
      if (res.data.Data.FilesNo) {
        const customHeaders = {
          Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55X2NvZGUiOiJzaWlhIiwidXNlcm5hbWUiOiJhZG1pbi5pcm1zIiwiaWF0IjoxNjY4NTY5NjY5LCJleHAiOjYxNjY4NTY5NjA5fQ.a390Qy5kVJV3jQ1L4iXOPeTWnYajbocEwuRDETKyS34"}`
        }
        const formData = new FormData()
        formData.append("FilesNo", res.data.Data.FilesNo)
        axios
          .post(Setting.dmsDownloadAPI, formData, { headers: customHeaders })
          .then((res) => {
            fileDownload(res.data, safeDecodeFileName(file?.FileName))
          })
      } else {
        axios.get(`${Setting.mailServerAPI}/${res.data.Data.FilesPath}`, {
          responseType: 'blob'
        }).then((res) => {
          fileDownload(res.data, safeDecodeFileName(file?.FileName))
        })
      }
    })
  } else {
    const blob_url = window.URL.createObjectURL(file)
    axios.get(blob_url, {
      responseType: 'blob'
    }).then((res) => {
      fileDownload(res.data, file?.name)
    })
  }
}

export const getSubSystemName = () => sessionStorage.getItem('SubSystemName') || "Mail Management"

export const fetchBusinessDetails = () => {
  return new Promise((resolve, reject) => {
    try {
      axios.get(`${Setting.mailServerAPI}/email/businessToEmailForBusiness`, {
        headers: {
          'X-Session-Token': sessionStorage.getItem('x-token') || ''
        }
      })
        .then((res) => {
          resolve(res.data?.Data?.canEdit === undefined || getBusinessData()?.canEdit?.toString()?.toLowerCase() === "true")
        })
    } catch (err) {
      resolve(true)
    }
  })
}

export const isAllowedToEdit = () => {
  const isAllowed = getBusinessData()?.canEdit === undefined || getBusinessData()?.canEdit?.toString()?.toLowerCase() === "true"
  return isAllowed
}

export function getTimezoneOffset() {
  const currentDate = new Date()
  const offsetInMinutes = -currentDate.getTimezoneOffset() // Invert the sign
  const hours = Math.floor(offsetInMinutes / 60)
  const minutes = offsetInMinutes % 60

  const sign = hours >= 0 ? "+" : "-"
  const formattedOffset = `${sign}${Math.abs(hours)}:${Math.abs(minutes).toString().padStart(2, '0')}`

  return `GMT ${formattedOffset}`.replace(":00", "")
}

export const getSystemConfig = (key) => {
  if (localStorage.getItem('system_config')) {
    const configValues = JSON.parse(localStorage.getItem('system_config'))
    const findIt = configValues.filter((a) => {
      return a?.sys_key === key
    })
    if (findIt.length === 1) {
      return findIt[0]
    } else {
      return false
    }
  }
  return false
}

export const getDateFormat = (lowCase = false) => {
  let checkFormat = getSystemConfig('dateFormat')?.sys_value
  checkFormat = checkFormat ? checkFormat : 'YYYY-MM-DD'
  if (lowCase) {
    checkFormat = checkFormat.replace('YYYY', 'Y')
    checkFormat = checkFormat.replace('DD', 'd')
    checkFormat = checkFormat.replace('MM', 'm')
  }
  return checkFormat
}